import { render, staticRenderFns } from "./SttrL_List.vue?vue&type=template&id=7c274566"
import script from "./SttrL_List.vue?vue&type=script&lang=js"
export * from "./SttrL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports